import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ModalRightService } from '../../../../../services/modal-right/modal-right.service';
import { ParametreDocumentStateService } from '../../../../../services/parametre-document/parametre-document-state.service';
import { PARAMETRE_TYPE_DOCUMENT_ACHAT } from '../../../../../services/parametre-document/parametre-document-type-ids';
import { saveParametreDocTypeRow } from '../../../../../services/parametre-document/parametre-document-child-save.util';

@Component({
    selector: 'app-doc-achat-bon-livraison',
    templateUrl: './doc-achat-bon-livraison.component.html',
    styleUrls: ['./doc-achat-bon-livraison.component.scss']
})
export class DocAchatBonLivraisonComponent implements OnInit {
    saving = false;
    /** Bon de réception achat (aligné sur typeDocumentIdMap BON RECEPTION) */
    private readonly typeId = PARAMETRE_TYPE_DOCUMENT_ACHAT.bonReception;

    constructor(
        private customizerService: ModalRightService,
        private state: ParametreDocumentStateService,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.state.ensureLoaded().subscribe();
    }

    saveParametreDocument(): void {
        saveParametreDocTypeRow(this.state, this.toastr, this.typeId, 'achat', {}, (v) => (this.saving = v));
    }

    appercue(): void {
        this.customizerService.open();
    }
}
